import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import {
  ARC_LARGE_LEFT,
  ARC_SMALL_LEFT,
  SvgPathBuilder,
} from '../../../svg/SvgPathBuilder';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createCircleNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawCircleBackground } from '../drawIconBackground';

const DIAMETER = 40;

function createCloudInternetGwIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const cloud = makeTag('path', {
    d: new SvgPathBuilder()
      .moveTo(-9.2, 6)
      .circleTo(4.4, ARC_SMALL_LEFT)(-10.4, -3.2)
      .circleTo(7.2, ARC_SMALL_LEFT)(3.2, -6.4)
      .circleTo(3.72, ARC_SMALL_LEFT)(9.2, -3.6)
      .circleTo(4.4, ARC_LARGE_LEFT)(8.4, 6)
      .buildClosed(),
    fill: 'none',
    stroke: ICON_DEFAULT_FOREGROUND_COLOR,
    'stroke-width': 2,
  });

  const icon = `${drawCircleBackground(DIAMETER / 2, opts.style)}
    ${cloud}
  `;

  return wrapNodeIconInSvgTag(icon, DIAMETER, DIAMETER, 'center', opts);
}

export const cloudInternetGwIcon: NodeTypeIcon = createCircleNodeTypeIcon(
  DIAMETER,
  createCloudInternetGwIcon,
);
